import React from 'react';
import PropTypes from 'prop-types';
import { TextField as MUITextField } from '@mui';
import { withStyles } from 'tss-react/mui';
import * as colors from '@constants/colors';
import { detailEdit } from '@constants/mui-theme';
import './input-autocomplete-content.scss';

const TextField = withStyles(MUITextField, {
  root: {
    '& input.Mui-disabled': {
      color: colors.dotmapsBlack40,
      WebkitTextFillColor: colors.dotmapsBlack40
    },
    '& label.Mui-disabled': {
      color: colors.dotmapsBlack40
    }
  }
});

// Convert legacy props to MUI v4 TextField props
const toTextFieldProps = ({
  errorText,
  floatingLabelText,
  inputStyle, // eslint-disable-line no-unused-vars
  textareaStyle, // eslint-disable-line no-unused-vars
  floatingLabelStyle, // eslint-disable-line no-unused-vars
  floatingLabelShrinkStyle, // eslint-disable-line no-unused-vars
  underlineStyle, // eslint-disable-line no-unused-vars
  underlineFocusStyle, // eslint-disable-line no-unused-vars
  style,
  value,
  ...rest
}) => ({
  ...rest,
  value,
  error: Boolean(errorText),
  helperText: errorText || null,
  ...(errorText && { FormHelperTextProps: { style: detailEdit.errors } }),
  label: floatingLabelText,
  InputLabelProps: { shrink: Boolean(value) },
  style: { width: '100%', marginTop: '1rem', ...style }
});

const InputAutocompleteContent = ({
  getInputProps,
  getSuggestionItemProps,
  inputProps,
  suggestions
}) => (
  <div data-testid="input-autocomplete-content" styleName="input-autocomplete-content-container">
    <TextField
      {...toTextFieldProps(inputProps)}
      onBlur={getInputProps().onBlur}
      onKeyDown={getInputProps().onKeyDown}
      onChange={getInputProps().onChange}
    />
    {suggestions.length > 0 && (
      <div styleName="suggestions-container">
        {suggestions.map(suggestion => (
          <div
            key={suggestion.id}
            styleName={`suggestion-item ${suggestion.active ? 'suggestion-item-active' : ''}`}
            {...getSuggestionItemProps(suggestion, {})}
          >
            <span>{suggestion.description}</span>
          </div>
        ))}
      </div>
    )}
  </div>
);

InputAutocompleteContent.propTypes = {
  getInputProps: PropTypes.func,
  getSuggestionItemProps: PropTypes.func,
  inputProps: PropTypes.object.isRequired,
  suggestions: PropTypes.array
};

export default InputAutocompleteContent;
